import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, type OnInit, signal, type WritableSignal } from '@angular/core';
import { switchMap, timer } from 'rxjs';

import { DiagnosticRating, MaloupeEventName } from '@malou-io/package-utils';

import { DiagnosticHttpService } from ':core/http-services/diagnostic.http-service';
import { listAnimation } from ':shared/animations';
import { FETCH_DIAGNOSTICS_INTERVAL, MAX_DIAGNOSTICS_TO_DISPLAY } from ':shared/constants';
import { Icon } from ':shared/enums';
import { Diagnostic } from ':shared/models';
import { ImagePathResolverPipe } from ':shared/pipes';

@Component({
    selector: 'app-equip-hotel-ranking',
    imports: [NgClass, ImagePathResolverPipe],
    templateUrl: './equip-hotel-ranking.component.html',
    styleUrl: './equip-hotel-ranking.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [listAnimation],
})
export class EquipHotelRankingComponent implements OnInit {
    readonly Icon = Icon;
    readonly DiagnosticRating = DiagnosticRating;

    diagnostics: WritableSignal<Diagnostic[]> = signal([]);

    private readonly _diagnosticsHttpService = inject(DiagnosticHttpService);

    ngOnInit(): void {
        this._initDiagnosticWatcher();
    }

    private _initDiagnosticWatcher(): void {
        timer(0, FETCH_DIAGNOSTICS_INTERVAL)
            .pipe(switchMap(() => this._diagnosticsHttpService.getEventDiagnostics$(MaloupeEventName.EQUIP_HOTEL)))
            .subscribe((diagnostics) => {
                const sortedDiagnostics = diagnostics
                    .map((diagnostic) => new Diagnostic(diagnostic))
                    .sort((a, b) => b.getTotalScore() - a.getTotalScore());
                this.diagnostics.set(sortedDiagnostics.slice(0, MAX_DIAGNOSTICS_TO_DISPLAY));
            });
    }
}
